import { render, staticRenderFns } from "./WebView.vue?vue&type=template&id=201edf78&scoped=true"
import script from "./WebView.vue?vue&type=script&lang=js"
export * from "./WebView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201edf78",
  null
  
)

export default component.exports